var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VQrCode',_vm._g(_vm._b({ref:"vQrCode",attrs:{"value":_vm.qrCodeContent}},'VQrCode',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }